import ComponentModule from "@eisinc/Overrides/Components/WishListSharingStatus";

export * from "@eisinc/Overrides/Components/WishListSharingStatus";

export default ComponentModule;
